module.exports = __webpack_public_path__ + "img/four4Orange.bd57d806.jpg";